






























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import PageTitle from '@shared/layouts/components/page-title/page-title.vue';

@Component({
  name: 'bpc-page-content-wrapper',
  components: {
    'bpc-page-title': PageTitle,
  },
})
export default class PageContentWrapper extends Vue {
  // PROPS
  @Prop({ type: String, default: '' }) readonly componentId: string;
  @Prop({ type: String, default: '' }) readonly bodyClass: string;

  // DATA
  // LIFECYCLE
  // created() { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  // COMPUTED
  // METHODS
  // WATCHERS
}
